// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2024 (original work) Open Assessment Technologies SA
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License

import config from '@/config';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

export const routing = [
    {
        path: [config.routes.campaigns.home],
        guard: getPermissionsGuard([{ resource: 'portal.campaign', scopes: ['view'] }]),
        controller: () => import('./controllers/campaigns')
    },
    {
        path: [config.routes.campaigns.create],
        guard: getPermissionsGuard([{ resource: 'portal.campaign', scopes: ['create'] }]),
        controller: () => import('./controllers/campaign.create.edit')
    },
    {
        path: [config.routes.campaigns.edit],
        guard: getPermissionsGuard([{ resource: 'portal.campaign', scopes: ['edit'] }]),
        controller: () => import('./controllers/campaign.create.edit')
    }
];
